import { ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { showAddTVSheet, tvBenchProductTypes } from '../TVFeature';

const showTVSheet = ({ coreApi, dispatch, rootState, props }: BehaviorParameters) => {
  const product = rootState.products.inMarket.find(p => p.coreProductId === props.coreProductId);
  const tvIsInScene = coreApi.entities.getByProductTypes([
    ProductType.TV,
    ProductType.TV_WITH_FOOT
  ]);
  const tvBenchAdded = product && tvBenchProductTypes.includes(product.type);

  if (tvBenchAdded && tvIsInScene.length <= 0) {
    dispatch(showAddTVSheet());
  }
};

export default showTVSheet;
